(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[456],{

/***/ 8859:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/astro/astrologers",
      function () {
        return __webpack_require__(48228);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 48228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ astrologers; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/layout/layout.tsx + 22 modules
var layout = __webpack_require__(16559);
;// CONCATENATED MODULE: ./src/assets/images/sub-banner-astro.png
/* harmony default export */ var sub_banner_astro = ({"src":"/_next/static/media/sub-banner-astro.a9d03a10.png","height":505,"width":1920,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAABlBMVEUPCRocGDDXeyxxAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAEklEQVR4nGNgAAJGRkYGBhgDAAA/AAe9OkA/AAAAAElFTkSuQmCC"});
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/styles/astrologerList.module.scss
var astrologerList_module = __webpack_require__(61916);
var astrologerList_module_default = /*#__PURE__*/__webpack_require__.n(astrologerList_module);
// EXTERNAL MODULE: ./src/api/http-client.ts
var http_client = __webpack_require__(55642);
// EXTERNAL MODULE: ./src/api/endpoints.ts
var endpoints = __webpack_require__(3557);
// EXTERNAL MODULE: ./src/components/common/currency-inr.tsx
var currency_inr = __webpack_require__(76630);
// EXTERNAL MODULE: ./src/lib/unbxd.ts
var unbxd = __webpack_require__(22236);
;// CONCATENATED MODULE: ./src/pages/astro/astrologers.tsx













var AstrologerList = function() {
    var ref = (0,react.useState)([]), data = ref[0], setData = ref[1];
    var loadList = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return http_client/* default.get */.Z.get(endpoints/* default.astro.astrologerList */.Z.astro.astrologerList());
                    case 3:
                        data = _ctx.sent.data;
                        setData(data);
                        _ctx.next = 9;
                        break;
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function loadList() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        loadList();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (astrologerList_module_default()).astro_banner,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: sub_banner_astro,
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (astrologerList_module_default()).astro_banner_text,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container h_100",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (astrologerList_module_default()).astro_banner_main,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (astrologerList_module_default()).astro_banner_main_text,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        children: "Hassle–free Astro Consultation"
                                    })
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (astrologerList_module_default()).astrologer_filter,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row justify-content-end"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (astrologerList_module_default()).astrologer_main,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row",
                        children: !!data.length && data.map(function(v) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-4 col-sm-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/astro/book-appointment/".concat(v.uuid),
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (astrologerList_module_default()).astrologer_main_card,
                                            onClick: function() {
                                                if (window.smartech) {
                                                    (0,unbxd/* unbxdCusEngTrackEvent */.$z)("astro_book_clicked", {
                                                        name: v.name,
                                                        experience: v.experience,
                                                        fees: v.fee,
                                                        prid: v.uuid,
                                                        image: v.image,
                                                        amount: v.offer_fee ? v.offer_fee : v.fee,
                                                        url: "".concat("https://sencogoldanddiamonds.com", "/astro/book-appointment/").concat(v.uuid),
                                                        discounted_price: v.offer_fee
                                                    });
                                                }
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                                    children: v.image && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: v.image,
                                                        alt: v.name,
                                                        width: "354px",
                                                        height: "236px"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "p-4",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (astrologerList_module_default()).heading,
                                                            children: v.name
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            className: (astrologerList_module_default()).text_limit,
                                                            children: [
                                                                v.info,
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (astrologerList_module_default()).expri,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: (astrologerList_module_default()).exp_sub,
                                                                    children: "Experience"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    className: (astrologerList_module_default()).exp_red,
                                                                    children: [
                                                                        ": ",
                                                                        v.experience,
                                                                        " Years"
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (astrologerList_module_default()).expri,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "d-flex",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: (astrologerList_module_default()).exp_sub,
                                                                        children: "Fees :"
                                                                    }),
                                                                    v.offer_fee && v.offer_fee !== v.fee && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (astrologerList_module_default()).price2,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(currency_inr/* default */.Z, {
                                                                                value: v.fee
                                                                            })
                                                                        })
                                                                    }),
                                                                    " ",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        className: (astrologerList_module_default()).exp_red,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(currency_inr/* default */.Z, {
                                                                                value: v.offer_fee ? v.offer_fee : v.fee
                                                                            }),
                                                                            "/-"
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (astrologerList_module_default()).more,
                                                            children: "Select"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            });
                        })
                    })
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var astrologers = (AstrologerList);


/***/ }),

/***/ 61916:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"astro_banner":"astrologerList_astro_banner__brwRV","astro_banner_text":"astrologerList_astro_banner_text__vnE0y","astro_banner_main":"astrologerList_astro_banner_main__OJlmM","astro_banner_main_text":"astrologerList_astro_banner_main_text__8otiA","astrologer_filter":"astrologerList_astrologer_filter__rVb_8","astrologer_main":"astrologerList_astrologer_main__a1z57","astrologer_main_card":"astrologerList_astrologer_main_card__IMXIC","heading":"astrologerList_heading__Lz5RM","text_limit":"astrologerList_text_limit__eqlfG","price2":"astrologerList_price2__kbEgQ","expri":"astrologerList_expri__kS_iK","exp_sub":"astrologerList_exp_sub__Tmu0B","exp_red":"astrologerList_exp_red__xbpoy","button":"astrologerList_button__9vb_K","more":"astrologerList_more__6fhKN","horoscope_astro_head":"astrologerList_horoscope_astro_head__R03Ab"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8523,4766,5675,9915,2640,3913,536,486,6646,1251,9774,2888,179], function() { return __webpack_exec__(8859); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);